import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-forms",
  "use": "icon-forms-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-forms\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 127.616C0 57.152 57.28 0 127.616 0h768.768C966.848 0 1024 57.28 1024 127.616v768.768A127.68 127.68 0 0 1 896.384 1024H127.616A127.68 127.68 0 0 1 0 896.384V127.616zM448 384h384V256H448v128z m0 192h384V448H448v128z m0 192h384v-128H448v128zM160 384h192V256h-192v128z m0 192h192V448h-192v128z m0 192h192v-128h-192v128z\" p-id=\"2171\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/forms.svg
// module id = gmfb
// module chunks = 81